"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SEOLinks;

var _react = _interopRequireDefault(require("react"));

var _NoScript = _interopRequireDefault(require("../NoScript"));

function SEOLinks(_ref) {
  var root = _ref.root;
  if (!root) return null;
  var links = [],
      key = 0;

  var findLinks = function findLinks(_ref2) {
    var items = _ref2.items;
    if (!items) return;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      if (item.href) {
        links.push( /*#__PURE__*/_react["default"].createElement("a", {
          key: key++,
          href: item.as
        }, item.text));
      }

      if (item.items) {
        findLinks(item);
      }
    }
  };

  findLinks(root);
  return /*#__PURE__*/_react["default"].createElement(_NoScript["default"], null, /*#__PURE__*/_react["default"].createElement("nav", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '1px',
      width: '1px',
      overflow: 'hidden'
    }
  }, links));
}
